module.exports = __webpack_public_path__ + "img/report-word.ac184f35.png";